import $ from "jquery";

const SELECTOR_CONTAINER = '[data-js="jsAjax"]';
const SELECTOR_CONTAINER_REPLACE = '[data-js="jsAjaxReplace"]';

const setup = function (el) {
  const url = $(el).attr("data-url");
  $(el).load(url, function (response, status, xhr) {});
};

const replace = function (el) {
  const url = $(el).attr("data-url");
  $(el)
    .load(url, function (response, status, xhr) {
      const image = $(this).contents().unwrap();

      // allows srcset img to be load on safari.
      // https://stackoverflow.com/questions/45487105/ajax-loaded-images-in-safari-not-respecting-srcset
      $(image).each((index, img) => {
        img.outerHTML = img.outerHTML;
      });
    })
    .hide()
    .fadeIn("slow");
};

const init = function () {
  $(SELECTOR_CONTAINER).each(function () {
    setup(this);
  });

  $(SELECTOR_CONTAINER_REPLACE).each(function () {
    replace(this);
  });
};

$(function () {
  init();
});

$(document).on("storybook:component:change", function () {
  init();
});
